// extracted by mini-css-extract-plugin
module.exports = {"peppertypeAI_page_hero":"__peppertypeAI_page_hero__pPJZF"};